import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import RcTransferList from './RcTransferList';
import { getAllRcTransfer } from 'services/redux/RcTransfer/action';

const mapStateToProps = (state) => ({
  rcTransferListing: state.rcTransferReducer.rcTransferListing
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAllRcTransfer
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(RcTransferList);
